import { render } from "./RecordEditor.vue?vue&type=template&id=67a31371"
import script from "./RecordEditor.vue?vue&type=script&lang=js"
export * from "./RecordEditor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__